<template>
  <v-app class="us-v-app">
    <v-app-bar color="blue-grey" dense dark app>
      <v-btn icon @click="goBack" v-if="hasBack==='true'">
        <v-icon style="font-size:2rem;">mdi-chevron-left</v-icon>
      </v-btn>
      <v-toolbar-title style="font-size:1rem;width:100%;">
        <span style="width:100%;text-overflow:ellipsis;overflow:hidden;white-space:nowrap;display:inline-block;margin-top:0.56rem;">
          巡检消息
          <span v-if="companyInfo.COMPANY_NAME">- {{companyInfo.COMPANY_NAME}}</span>
        </span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
    </v-app-bar>
    <v-content>
      <v-container style="font-size:0.9rem;padding:0.9rem 1.1rem 5rem;color:rgba(33, 33, 33, 0.9);">
        <div v-if="loading" style="margin-top:10rem;">
          <LoadingText />
        </div>
        <div v-else>
          <PollingDetailMsg :deviceInfo="deviceInfo" :recordInfo="recordInfo" :notifyInfo="notifyInfo" :pollingInfo="pollingInfo" :downloadUrl="downloadUrl"/>
        </div>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import LoadingText from '../../components/LoadingText'
import PollingDetailMsg from './components/PollingDetailMsg'
export default {
  components: { LoadingText, PollingDetailMsg },
  props: {
  },
  data() {
    return {
      iotId: '',
      propInfo: {},
      deviceInfo: {},
      showMoreProp: false,
      companyInfo: {},
      activated: true,
      loading: true,
      notifyCode: 0,
      alertInfo: {},
      recordInfo: {},
      notifyInfo: {},
      pollingInfo: {},
      list: [
        { label: '15分钟', value: 15 },
        { label: '30分钟', value: 30 },
        { label: '1小时', value: 60 },
        { label: '2小时', value: 120 },
        { label: '3小时', value: 180 },
        { label: '4小时', value: 240 },
        { label: '5小时', value: 300 }
      ],
      selectVal: 15,
      alertOrder: {},
      pro_user: {},
      hasBack: false,
      downloadUrl: ''
    }
  },
  computed: {
  },
  async mounted() {
    var that = this
    that.notifyCode = that.$route.params.code ? that.$route.params.code : ''
    that.hasBack = that.$route.query.has_back ? that.$route.query.has_back : false
    await that.getDeviceAlert()
    await that.getDevice()
    that.loading = false
  },
  created() {
  },
  methods: {
    goBack() {
      this.$router.goBack()
    },
    async getDevice() {
      var that = this
      await that.$api.iot.getDevice({ iot_id: that.iotId }).then(res => {
        // console.log('getDevice.res', res);
        if (!res.success) {
          // that.$toast.warning('获取设备信息失败')
          console.log('获取设备信息失败', res);
          return
        }
        var data = res.data
        that.deviceInfo = data.device
        that.companyInfo = data.company
        that.activated = that.deviceInfo.CUR_SID !== '0'
      })
    },
    async getDeviceAlert() {
      var that = this
      await that.$api.aishu.getPollingAlertRecord({ code: that.notifyCode }).then(res => {
        // console.log('getPollingAlertRecord.res', res);
        if (!res.success) {
          // that.$toast.error('获取设备信息失败')
          console.log('获取设备警报信息失败', res);
          return
        }
        var data = res.data
        that.iotId = data.record.DEVICE_IOT_ID
        that.notifyInfo = data.notify
        that.recordInfo = data.record
        that.pollingInfo = data.polling
        that.downloadUrl = data.download_url
      })
    },
    // 时间格式化
    getTimeStr(sec) {
      var strDura = ''
      var dura = 0
      if (sec >= 86400) {
        dura = Number.parseInt(sec / 60 / 60 / 24);
        strDura = dura + ' 天';
      } else if (sec >= 3600) {
        dura = Number.parseInt(sec / 60 / 60);
        strDura = dura + ' 小时';
      } else if (sec >= 60) {
        dura = Number.parseInt(sec / 60);
        strDura = dura + ' 分钟';
      } else {
        strDura = dura + ' 秒';
      }
      return strDura
    }
  }
}
</script>

<style scoped>
.ss{
  position: relative;
}
</style>
